module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"success":"上传成功","error":"上传出错","uploading":"上传中","paused":"暂停中","waiting":"等待中","cmd5":"计算md5中..."},"en":{"success":"Success","error":"Error","uploading":"Uploading","paused":"Paused","waiting":"Waiting","cmd5":"Computing MD5..."}}')
  delete Component.options._Ctor
}
